/** The separator's own layout: how thick the bar is, the room around it, and the size of its grip. */
export const RESIZER = {
  thickness: 4,
  gutter: 10,
  iconSize: 16,
} as const;
